import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useResetAll } from "../../data/useResetAll.ts";
import ffsLogo from "../../assets/home/ww-ffs-logo.png";
import iwmiLogo from "../../assets/home/ww-iwmi-logo.png";
import mflLogo from "../../assets/home/ww-mfl-logo.png";
import Header from "../../components/header/header.tsx";
import Login from "../../components/login/login.tsx";
import Title from "../../components/title/title.tsx";
import "./start.css";

import Button from "../../components/button/button.tsx";

const Start = () => {
    const navigate = useNavigate();
    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const resetAll = useResetAll();

    useEffect(() => {
        resetAll();
    }, [resetAll]);

    const openLogin = () => setIsLoginOpen(true);
    const closeLogin = () => setIsLoginOpen(false);

    const handleQuickAnalysis = () => {
        navigate("/goal-setting");
    };

    return (
        <>
            <Header />
            <div className="home-container">
                <div className="home-container__intro-container">
                    <div className="home-hero-section">
                        <Title>WasteWise</Title>
                        <p className="home-subtitle">
                            Enabling Circular Economy Through Intelligent Decision Support
                        </p>
                        <div className="home-buttons">
                            <Button
                                backgroundColor="var(--color-green)"
                                onClick={handleQuickAnalysis}
                            >
                                Quick Analysis →
                            </Button>
                            <span className="home-button-divider">or</span>
                            <Button
                                backgroundColor="var(--color-white)"
                                transparent={true}
                                onClick={openLogin}
                            >
                                Sign In
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="home-container__credits-container">
                    <div>
                        <h6>Presented by</h6>
                        <img
                            className="iwmi-logo"
                            src={iwmiLogo}
                            alt="International Waste Management Institute Logo"
                        />
                        <hr />
                        <img
                            className="mfl-logo"
                            src={mflLogo}
                            alt="Multifunctional Landscapes Logo"
                        />
                        <img
                            className="ffs-logo"
                            src={ffsLogo}
                            alt="Food Frontiers And Security Logo"
                        />
                    </div>
                </div>

                <Login isOpen={isLoginOpen} onClose={closeLogin} />
            </div>
        </>
    );
};

export default Start;
